/**
 * Route for `campaign-archive`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignArchivePage } from "../features/campaign-archive/CampaignArchivePage";

export const campaignArchiveRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-archive",
	component: CampaignArchivePage,
});

export default campaignArchiveRoute;
